import Icon, { IconProps } from './Icon';

import AlarmClockIcon from '../../../assets/icons/alarm-clock.svg?react';

const AlarmClock: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <AlarmClockIcon />
        </Icon>
    );
};

export default AlarmClock;
